import React, { ReactElement, useEffect } from 'react';
import { Column, Grid, Row, Button, ButtonSet } from 'carbon-components-react';

import { FormattedMessage } from 'react-intl';
import { scrollTo } from 'src/common/utils/smoothScroll';
import { segmentTracking } from '../lib/tracker';
import messages from '../locales/messages';
import './RPAPriceEstimator.scss';
import { cookieContentObject, roiCookieContent } from './RPAPriceEstimator';
import ThanksDetails from 'src/apps/rpa-roi-estimator/components/ThanksDetails';

export interface thanksProps {
  productToAcquire: string;
  numberOfUnattendedRobots: number;
  numberOfAttendedRobots: number;
  numberOfEnvironments: number;
  montlyCost: string;
  cookieContent: roiCookieContent;
  bpName: string;
  bpConsentMail: boolean;
}

const Thanks = ({
  productToAcquire,
  numberOfUnattendedRobots,
  numberOfAttendedRobots,
  numberOfEnvironments,
  montlyCost,
  cookieContent,
}: thanksProps): ReactElement => {
  useEffect(() => {
    scrollTo('ThankYou');
  }, []);

  const render = (
    <Grid id="ThankYou">
      <Row>
        <Column sm={4} md={8} lg={12}>
          <div className="bx--row padding-row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-16">
              <div className="thanks__pad1 page_heading">
                <FormattedMessage {...messages.thankYouTitle} />
              </div>
              <div className="page_sub_heading">
                <FormattedMessage {...messages.thankYouSubTitle} />
              </div>
              <div className="page_sub_heading_2 thanks__pad2">
                <FormattedMessage {...messages.thankYouDetailsTitle} />
              </div>
              <div className="thanks__requirement thanks__pad4">
                <FormattedMessage {...messages.numberOfEnvironments} />:
                <strong>{` ${numberOfEnvironments}`}</strong>
                <br />
                <FormattedMessage {...messages.numberOfUnattendedRobots} />:
                <strong>{` ${numberOfUnattendedRobots}`}</strong>
                <br />
                <FormattedMessage {...messages.numberOfAttendedRobots} />:
                <strong>{` ${numberOfAttendedRobots}`}</strong>
                <br />
                <FormattedMessage {...messages.productToAcquire} />:
                <strong>{` ${productToAcquire}`}</strong>
                <br />
                <FormattedMessage {...messages.estimatedCosts} />:
                <strong>{` ${montlyCost}`}</strong>
                <br />
                {Object.keys(cookieContent).length !== 0 &&
                cookieContent.estimate.length !== 0 ? (
                  <>
                    <div className="page_sub_heading_2 thanks__pad2">
                      ROI
                      {` `}
                      <FormattedMessage {...messages.thankYouDetailsTitle} />
                    </div>
                    <ThanksDetails
                      currentNumberOfHoursPerWeek={
                        cookieContent.currentNumberOfHoursPerWeek
                      }
                      currentFullTimeEmployeeCost={
                        cookieContent.currentFullTimeEmployeeCost
                      }
                      errorRate={cookieContent.errorRate}
                      numberOfProcessToAutomate={
                        cookieContent.numberOfProcessToAutomate
                      }
                      roiValue={cookieContent.estimate}
                    ></ThanksDetails>
                  </>
                ) : null}
              </div>
              <ButtonSet className="RPA_PE__stack-button" stacked>
                <Button
                  onClick={() => {
                    segmentTracking('CTA Clicked', {
                      pageTitle: 'Turbonomic Pricing Page',
                      object: 'Pricing page',
                      resultValue: 'CTA clicked',
                      CTA: 'Return to Estimator',
                      location: 'Thankyou',
                      action: '',
                      field: '',
                    });
                    window.location.reload();
                  }}
                >
                  <FormattedMessage {...messages.returnToEstimator} />
                </Button>
              </ButtonSet>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
  localStorage.setItem(
    'formContent',
    JSON.stringify({
      message: cookieContent,
      content: cookieContentObject,
    }),
  );
  return render;
};

export default Thanks;
